import * as React from 'react';
import * as firebase from 'firebase/app';
import { Dispatch } from 'react-redux';
import { Table, Card, Button, Popconfirm, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AppState, FeaturedAds, Merchant } from 'src/store';
import { actions as toast } from 'src/toast';
import ButtonGroup from 'antd/lib/button/button-group';
import { Subscription } from 'rxjs';
import { querySnapShot$ } from 'src/util';

const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    navigate: (route: string) => {
      dispatch(push(route));
    },
    onEdit: (id: string) => { dispatch(push(`/featuredAds/edit/${id}`)); },
    onDelete: async (id: string) => {
      const ref = firebase.firestore().collection('featuredAds');
      if (id) {
        const doc = ref.doc(id)
        await doc.delete()
        dispatch(toast.success('Featured Ads is deleted successfully.'));
      }
    },
  };
};

interface P {
  navigate: (route: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => Promise<void>;
}
type S = {
  status: 'none' | 'loading';
} | {
  status: 'loaded';
  data: FeaturedAds[];
}
class FeaturedAdsList extends React.Component<P, S> {
  columns: ColumnProps<FeaturedAds>[];
  subscription: Subscription;

  constructor(props: P) {
    super(props);
    this.state = { status: 'none' };
    this.subscription = new Subscription();
  }

  componentDidMount() {
    this.setState({ status: 'loading' });
    const query = firebase.firestore()
      .collection('featuredAds')
      .orderBy("name")

    this.subscription = querySnapShot$(query)
      .subscribe(qsn => {
        const data = qsn.docs.map(d => ({ id: d.id, ...d.data() } as FeaturedAds));
        this.setState({ status: 'loaded', data });
      });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleOnAdd = () => {
    const { navigate } = this.props;
    navigate(`/featuredAds/create`);
  }

  getMerchantNames = (merchants?: Merchant[]) => {
    let resultString = "";
    if (merchants && merchants.length > 0) {
        merchants.forEach(merchant => {
        resultString += merchant.businessName + ", ";
      })
      // remove the extra comma at the end, using a regex
      resultString = resultString.replace(/,(?=[^,]*$)/, '')
    }
    return resultString
  }

  render() {
    const { onEdit, onDelete } = this.props;

    this.columns = [{
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      width: '5%',
      render: (text: string, record: FeaturedAds, index: number) => {
        return <span>{record.no}</span>;
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '30%',
    },
    {
        title: 'Merchants',
        // dataIndex: 'creat',
        width: '15%',
        // tslint:disable-next-line:no-any
        render: (text: string, record: FeaturedAds) => {
          return <span>{this.getMerchantNames(record.merchants)}</span>;
        }
      },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      width: '15%',
      render: (text: string, record: FeaturedAds) => {

        return (
          <ButtonGroup>
            <Tooltip placement="top" title="Click to edit featured ads">
              <Button
                icon="edit"
                // tslint:disable-next-line:jsx-no-lambda
                onClick={() => { onEdit(record.id); }}
              />
            </Tooltip>
            <Popconfirm
              title="Are you sure you want to delete this featured ads?"
              // tslint:disable-next-line:jsx-no-lambda
              onConfirm={() => { onDelete(record.id); }}
              // onCancel={cancel} 
              okText="Yes"
              cancelText="No"
            >
              <Tooltip placement="top" title="Click to delete featured ads">
                <Button icon="delete" />
              </Tooltip>
            </Popconfirm>

          </ButtonGroup>
        );
      }
    }
    ];

    const data = this.state.status === 'loaded' ? this.state.data : [];

    const dataSource = data.map((d, i) => ({
      no: i + 1,
      ...d
    }));

    return (
      <Card
        loading={this.state.status === 'loading'}
        title="Featured Ads List"
        bordered={true}
        bodyStyle={{ padding: 10 }}
        extra={
          <Button type="primary" icon="plus" onClick={this.handleOnAdd}>
            Create
              </Button>
        }>
        <Table
          columns={this.columns}
          dataSource={dataSource}
          pagination={false}
          size="middle"
          bordered={true}
        />
      </Card>
    );
  }
}

export default connect(st => ({}), mapDispatchToProps)(FeaturedAdsList);



// WEBPACK FOOTER //
// ./src/featuredAds/containers/FeaturedAdsList.tsx